import { Modal } from "components/ui/modals/Modal/Modal"
import { H3 } from "components/ui/typography/titles/Titles"
import { useDeleteCategoryStore } from "store/configuration.store"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { ButtonWarning } from "components/ui/buttons/ButtonWarning/ButtonWarning"
import { useDeleteCategory, useObjectsCategories } from "hooks/api/objectsCategories/objectsCategories.hook"
import { useMessage } from "hooks/message.hook"
import { Skeleton } from "components/ui/skeleton/Skeleton"
import style from "./DeleteCategoryModal.module.scss"

const { title, categoryName, warningText, buttonsBlock, deleteButton } = style

export const DeleteCategoryModal = () => {
	const { isDeleteCategoryModalOpen, setDeleteCategoryModalClose, deleteCategoryData } = useDeleteCategoryStore()
	const { mutate: deleteCategoryMutation, isPending: isDeleteCategoryPending } = useDeleteCategory()
	const { refetch: refetchObjectsCategories } = useObjectsCategories()
	const { success, error } = useMessage()

	const deleteCategoryHandle = () => {
		deleteCategoryMutation(deleteCategoryData.categoryId, {
			onSuccess: () => {
				success(`${deleteCategoryData.categoryName} successfully deleted`)
				setDeleteCategoryModalClose()
				refetchObjectsCategories()
			},
			onError: () => {
				error("Something went wrong, please try again later")
			},
		})
	}

	return (
		<Modal isModalOpen={isDeleteCategoryModalOpen} setModalClose={setDeleteCategoryModalClose} width={460}>
			{isDeleteCategoryPending ? (
				<div data-testid="skeleton">
					<Skeleton />
				</div>
			) : (
				<>
					<H3 className={title}>
						Delete <span className={categoryName}>{deleteCategoryData.categoryName}</span> object?
					</H3>
					<p className={warningText}>
						{deleteCategoryData.deletionWarningText
							? deleteCategoryData.deletionWarningText
							: "If you delete these files, you won’t be able to recover them."}
					</p>
					<div className={buttonsBlock}>
						<ButtonPrimary onClick={setDeleteCategoryModalClose}>Cancel</ButtonPrimary>
						<ButtonWarning onClick={deleteCategoryHandle} className={deleteButton}>
							Delete
						</ButtonWarning>
					</div>
				</>
			)}
		</Modal>
	)
}
